(() => {
  const cartAutoUpdate = window.MXCartAutoUpdate;

  if (
    !cartAutoUpdate ||
    typeof cartAutoUpdate.setupCartAutoUpdate !== 'function'
  ) {
    return;
  }

  document.addEventListener('DOMContentLoaded', () => {
    cartAutoUpdate.setupCartAutoUpdate(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    cartAutoUpdate.setupCartAutoUpdate(event.target);
  });
})();
